<template>
  <div class="menu-items-list">
    <food-window
      v-if="selectedItem"
      :item="selectedItem"
      @close="selectedItem = null"
    />

    <section v-else>
      <slot name="before-menu-items" />
      <div class="menu-items-content">
        <v-loader v-if="loading" absolute transparent />
        <template v-else>
          <v-row v-if="items.length" class="menu-items">
            <v-col
              v-for="item in items"
              :key="item.id"
              sm="4"
              xl="3"
              class="menu-item-col"
            >
              <food-card
                :item="item"
                new
                bonus
                child
                @openFoodWindow="openFoodWindow"
              />
            </v-col>
          </v-row>
          <span v-else class="d-block display-3 text-center">Ничего не найдено</span>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
  import FoodCard from '@/components/order-processing/order-components/first-step/FoodCard.vue'
  import VLoader from '@/components/loader/Loader.vue'
  import FoodCategories from '@/components/order-processing/order-components/food-categories/FoodCategories.vue'
  import FoodWindow from '@/components/order-processing/order-components/first-step/FoodWindow.vue'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'MenuItemsList',
    components: {
      FoodWindow,
      FoodCategories,
      VLoader,
      FoodCard,
    },
    props: {
      items: {
        type: Array,
        default: () => [],
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        selectedItem: null,
      }
    },
    methods: {
      openFoodWindow (item) {
        this.selectedItem = item
      },
    },
  }
</script>

<style scoped lang="less">
.menu-items-list {
  background: transparent;
  .menu-items {
    position: relative;
    z-index: 0;

  }

  .menu-items-content {
    position: relative;
    min-height: calc( 80vh - 300px);
  }

  // От 1700px четыре карточки в ряд: по сетке Vuetify (xl) они включаются
  // только с 1904px, а до того три карточки на таком экране слишком крупные
  @media (min-width: 1700px) {
    ::v-deep .menu-item-col {
      flex: 0 0 25%;
      max-width: 25%;
    }
  }

  // Уже 1200px между карточками 10px вместо 24px - карточкам нужна ширина
  // (вид карточки на этой ширине задаёт сама FoodCard)
  @media (max-width: 1199px) {
    ::v-deep .menu-item-col {
      padding: 5px;
    }
  }
}

</style>
